var _ellipse, _rect, _ellipse2, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgError = function SvgError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 59.8288,
    cy: 104.751,
    rx: 37.321,
    ry: 1.99934,
    fill: "url(#paint0_linear_820_104665)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85.0521,
    height: 85.0521,
    transform: "translate(16.7715 21.5625)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 58.6979,
    cy: 100.025,
    rx: 33.5417,
    ry: 1.79688,
    fill: "url(#paint1_linear_820_104665)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.248 85.8344C86.248 89.4769 83.2952 92.4297 79.6528 92.4297H40.5666C36.656 92.4297 33.4859 89.2596 33.4859 85.349V32.2386C33.4859 28.3281 36.656 25.1579 40.5666 25.1579H79.1674C83.0779 25.1579 86.248 28.3281 86.248 32.2386V85.8344Z",
    fill: "url(#paint2_linear_820_104665)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1699 79.8984L30.1889 79.8984C28.7319 79.8984 27.5438 81.081 27.6777 82.5318C28.0763 86.851 29.5036 92.4295 33.1903 92.4295L80.6427 92.4294C75.4039 92.4294 72.8344 86.778 72.0257 82.4475C71.7633 81.042 70.5997 79.8984 69.1699 79.8984Z",
    fill: "url(#paint3_linear_820_104665)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3105,
    y: 40.7305,
    width: 22.7604,
    height: 2.39583,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3105,
    y: 44.3242,
    width: 13.1771,
    height: 2.39583,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9258,
    y: 40.7305,
    width: 5.98958,
    height: 5.98958,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3105,
    y: 51.5117,
    width: 27.5521,
    height: 2.39583,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3105,
    y: 55.1055,
    width: 19.1667,
    height: 2.39583,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9258,
    y: 51.5117,
    width: 5.98958,
    height: 5.98958,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3105,
    y: 62.293,
    width: 14.375,
    height: 2.39583,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3105,
    y: 65.8867,
    width: 25.1562,
    height: 2.39583,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 41.9258,
    y: 62.293,
    width: 5.98958,
    height: 5.98958,
    rx: 1.19792,
    fill: "#EF9A9A"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5508,
    y: 20.3633,
    width: 7.98611,
    height: 20.7639,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.501 35.3343L49.5005 35.3333L39.2788 16.9342C37.716 14.1176 35.3125 12.1758 32.3409 12.1758C29.3695 12.1758 26.9663 14.1172 25.4035 16.9333C25.4033 16.9336 25.4031 16.9339 25.403 16.9342L15.1812 35.3334L15.1812 35.3333L15.1782 35.3388C13.6866 38.0459 13.3454 40.9993 14.8021 43.4869C16.2615 45.979 19.0205 47.123 22.1187 47.123L42.5631 47.123C45.6613 47.123 48.4203 45.979 49.8797 43.4869C51.3355 41.0008 50.9969 38.0305 49.501 35.3343Z",
    fill: "#EF5350",
    stroke: "white",
    strokeWidth: 3.59375
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_820_104665",
    x1: 105.632,
    y1: 103.019,
    x2: 103.899,
    y2: 117.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_820_104665",
    x1: 99.8627,
    y1: 98.4681,
    x2: 98.3054,
    y2: 111.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_820_104665",
    x1: 86.248,
    y1: 74.01,
    x2: 44.8808,
    y2: 36.5875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_820_104665",
    x1: 57.0755,
    y1: 92.4294,
    x2: 56.57,
    y2: 80.8877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE5E5"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "error.419c2aa3d0d08d20ab03afb626e7a59b.svg";